import VuexStore from "@/store/vuex/VuexStore";
import {User} from "@/app/utils/types";

/**
 * Returns the currently logged in user, or null if there is none.
 * @return {User}
 */
export function getUser() {
    return VuexStore.state.user ?? null;
}